const togglerSelector = `[data-toggler]`;
const togglers = document.querySelectorAll(togglerSelector);

const defaultOptions = {
  event: 'click'
};

togglers.forEach(toggler => {
  let options = JSON.parse(toggler.dataset.toggler);
  options = { ...defaultOptions, ...options };
  toggler.addEventListener(options.event, function () {
    document
      .querySelectorAll(options.targetSelector)
      .forEach((target) => target.classList.toggle(options.class));
  });
});